import { CaseType, IssueType } from "./api";

const dataYesNo: any = [
    {
        id: true,
        name: "Yes"
    },
    {
        id: false,
        name: "No"
    },
    {
        id: -1,
        name: "Not Applicable"
    }
];

// @ts-ignore
export const packingIntactData: any = [...dataYesNo];
export const tamperingData: any = [...dataYesNo];
export const sealIntactData: any = [...dataYesNo];

export const caseTypeData: any = [
    {
        id: CaseType.Complaint,
        name: "Complaint"
    },
    {
        id: CaseType.Claim,
        name: "Claim"
    },
    {
        id: CaseType.ComplaintClaim,
        name: "Complaint & Claim"
    }
];

export const complaintStatusData: any = [
    {
        id: true,
        name: "Open"
    },
    {
        id: false,
        name: "Closed"
    }
];

export const OnHoldStatusData: any = [
    {
        id: true,
        name: "Yes"
    },
    {
        id: false,
        name: "No"
    }
];

type InCaseOf = {
    id: number;
    name: string;
    info?: string;
};

export const inCaseOfShipmentData: InCaseOf[] = [
    { id: 1, name: "Delay" },
    { id: 2, name: "Damage" },
    { id: 3, name: "Missing" },
    { id: 4, name: "Short Shipment" },
    { id: 5, name: "Wrong Items Delivered" },
    { id: 6, name: "Early Delivery" },
    { id: 7, name: "Temperature Issue" },
    { id: 8, name: "Documentation Issue" },
    { id: 9, name: "Wrong Destination" },
    { id: 10, name: "Over Shipment" }
];

export const inCaseOfShipmentDataForIncident: InCaseOf[] = [
    { id: 2, name: "Damage" },
    { id: 3, name: "Missing" },
    { id: 4, name: "Short shipment" },
    { id: 7, name: "Temperature Issue" },
];

const inCaseOfGoodsMaterialReceipt: InCaseOf[] = [
    { id: 1, name: "Quality", info: "broken; damaged; wet; contaminated; expired stock; other quality related issues." },
    { id: 2, name: "Quantity", info: "shortages; overages." },
    { id: 3, name: "Packaging/Labeling", info: "mixed batches/POs/PO item lines; non-compliant labelling; non-compliant packaging; packaging/labelling requiring rework; non-compliant packaging materials (cartons, pallets, stretch wrap, etc)" },
    { id: 4, name: "Temperature Excursions", info: "" },
    { id: 5, name: "No data loggers", info: "" },
    { id: 6, name: "Unreadable data logger", info: "" },
    { id: 7, name: "Inadequate labeling of data logger placement", info: "" },
    { id: 8, name: "Non-reefer containers", info: "" },
];
const inCaseOfGoodsProduction: InCaseOf[] = [
    { id: 1, name: "Quality", info: "broken; damaged; wet; contaminated; expired stock; other quality related issues." },
    { id: 2, name: "Quantity", info: "shortages; overages." }
];
const inCaseOfGoodsDeliveryPacking: InCaseOf[] = [
    { id: 1, name: "Quality", info: "broken; damaged; wet; contaminated; expired stock; other quality related issues." },
    { id: 2, name: "Quantity", info: "shortages; overages." }
];
const inCaseOfOperationalIssues: InCaseOf[] = [
    { id: 1, name: "Downtime SSI", },
    { id: 2, name: "Equipment failure", },
    { id: 3, name: "Hub Service Provider failure", }
];

export const inCaseOfWarehouseNonConformity: Record<number, Array<InCaseOf>> = {
    [IssueType.GoodsMaterialReceipt]: inCaseOfGoodsMaterialReceipt,
    [IssueType.GoodsProduction]: inCaseOfGoodsProduction,
    [IssueType.GoodsDeliveryPacking]: inCaseOfGoodsDeliveryPacking,
    [IssueType.OperationalIssues]: inCaseOfOperationalIssues
}

export const recurrentData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    },
    {
        id: 2,
        name: "Under investigation"
    }
];

export const needForCorrectionData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    },
    {
        id: 2,
        name: "Pending"
    }
];

export const needforCorrectiveActionData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    },
    {
        id: 2,
        name: "Pending"
    }
];

export const oerData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    }
];

export const recallData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    }
];

export const complaintValidationData: any = [
    {
        id: 1,
        name: "Yes"
    },
    {
        id: 0,
        name: "No"
    },
    {
        id: 2,
        name: "Under investigation"
    }
];

export const responsibilityData: any = [
    {
        id: "FF",
        name: "FF"
    },
    {
        id: "Supplier",
        name: "Supplier"
    },
    {
        id: "SD",
        name: "SD"
    },
    {
        id: "Others",
        name: "Others"
    },
    {
        id: "N/A",
        name: "N/A"
    }
];

export const issueTypeData: any = ["Shipment", "Inventory", "Other"];

export const accessTypeData: any = [
    {
        id: 1,
        label: "Standard UNICEF Complaint/Claim"
    },
    {
        id: 2,
        label: "UNICEF/GAVI Incident Report"
    },
    {
        id: 3,
        label: "Both"
    }
];

export const UserRolesList: any = [
    // {
    //     id: 1,
    //     label: "Admin"
    // },
    {
        id: 2,
        label: "QMU"
    },
    {
        id: 3,
        label: "INS"
    },
    // {
    //     id: 4,
    //     label: "FMC"
    // },
    {
        id: 5,
        label: "Requestor"
    },
    // {
    //     id: 6,
    //     label: "Partner"
    // },
    {
        id: 7,
        label: "Solution Owner"
    },
    // {
    //     id: 8,
    //     label: "Solution Team"
    // }
];

export const WarehouseList: any = [
    {
        id: 1,
        name: "Brindisi (Italy)"
    },
    {
        id: 2,
        name: "DPW Dubai (UAE)"
    },
    {
        id: 3,
        name: "IHC Dubai (UAE)"
    },
    {
        id: 4,
        name: "Supply Division (Denmark)"
    },
    {
        id: 5,
        name: "SGL Taastrup (Denmark)"
    },
    {
        id: 6,
        name: "UNHRD (Panama)"
    },
    {
        id: 7,
        name: "Other"
    }
];